import React, { useCallback } from 'react'

import { useIntl } from '@app/intl/Intl'

import multiDownloader, { DownloadableDocument } from '../helpers/multiDownloader'

export type DownloadAllDocumentsButtonProps = {
  documents: DownloadableDocument[]
  className?: string
}

export const DownloadAllDocumentsButton = ({
  documents,
  className
}: DownloadAllDocumentsButtonProps) => {
  const { formatMessage } = useIntl()
  const downloadAllDocuments = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()
      multiDownloader(documents)
    },
    [documents]
  )

  return (
    <a href={''} className={className} onClick={downloadAllDocuments}>
      {formatMessage({ id: 'DownloadAllDocuments.Button' })}
    </a>
  )
}
